import { render } from "./TalkToMyDataInvocations.vue?vue&type=template&id=49c88592&scoped=true"
import script from "./TalkToMyDataInvocations.vue?vue&type=script&lang=js"
export * from "./TalkToMyDataInvocations.vue?vue&type=script&lang=js"

import "./TalkToMyDataInvocations.vue?vue&type=style&index=0&id=49c88592&scoped=true&lang=css"

import exportComponent from "/Users/rosswilliams/aqfer-workspace/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c88592"]])

export default __exports__